import { createFileRoute } from '@tanstack/react-router'
import FinancialPage from '../../../app/financial/page'

export const Route = createFileRoute('/_auth/financial/')({
  component: FinancialPage
})
